import { render, staticRenderFns } from "./SupervisorsReport.vue?vue&type=template&id=67de1dba"
import script from "./SupervisorsReport.vue?vue&type=script&lang=js"
export * from "./SupervisorsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports